import HelpCenter from '../../components/support/HelpCenter';

export default [
  {
    path: '/helpcenter',
    component: HelpCenter,
    meta: {
      allowFirstRoute: true,
      forceFirstRoute: true,
      hideProgressBar: true,
      isGameRoute: false, // TODO: set true to use app-wide forced landscape system
      useSignInForNavbar: true,
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/support/routes.js